import React, { useState, useEffect, useCallback, useRef } from 'react';
import { DS } from '../ds';
const slides = [{
  id: 4,
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/831df720-cd0a-4b82-819e-32bdeba701bc.jpg',
  alt: 'Alineadores invisibles junto a su estuche en un entorno clínico',
  label: 'Ortodoncia invisible',
  title: 'ALINEADORES\nINVISIBLES',
  sub: 'Tecnología de punta para una sonrisa perfecta',
  pill: '✓ Ortodoncia avanzada',
  align: 'center' as const,
  overlay: 'rgba(8,42,55,0.48)',
  objectPosition: 'center',
  objectPositionTablet: 'center',
  objectPositionMobile: '30% center'
}, {
  id: 1,
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/7fefb29e-c878-480a-885e-304c0aab38b9.jpg',
  alt: 'Laboratorio dental certificado INVIMA en Colombia',
  label: 'Respaldo institucional',
  title: 'HABILITADO CON\nCERTIFICACIÓN INVIMA',
  sub: 'Fabricación bajo normativa colombiana vigente',
  pill: '✓ Registro sanitario activo',
  align: 'left' as const,
  overlay: 'rgba(8,42,55,0.52)',
  objectPosition: 'center',
  objectPositionTablet: '100% center',
  objectFitTablet: 'contain' as const,
  objectPositionMobile: '0% center'
}, {
  id: 2,
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/b565b906-f37c-48dd-bb3c-d2e2c6f76d89.jpg',
  alt: 'Kit eco-premium de alineadores con caja kraft y bolsa de lino',
  label: 'Identidad de marca',
  title: 'PRODUCTO\nPERSONALIZADO',
  sub: 'Kit eco-premium con tu marca en cada entrega',
  pill: '✓ Caja kraft · Bolsa lino · Estuche',
  align: 'right' as const,
  overlay: 'rgba(8,42,55,0.45)',
  objectPosition: 'center',
  objectPositionTablet: 'center',
  objectPositionMobile: '34% center'
}, {
  id: 3,
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/bb1f62aa-2170-4e78-9945-8b42b6d2bd10.jpg',
  alt: 'Entrega express de alineadores a toda Colombia',
  label: 'Logística',
  title: 'TIEMPOS DE\nENTREGA EXPRESS',
  sub: 'Respuesta en menos de 24 horas',
  pill: '✓ Envío a toda Colombia',
  align: 'center' as const,
  overlay: 'rgba(8,42,55,0.48)',
  objectPosition: 'center',
  objectPositionTablet: 'center',
  objectPositionMobile: 'center'
}];
const ChevronLeft = () => <svg width="22" height="22" viewBox="0 0 22 22" fill="none" aria-hidden="true" data-id="element-569" data-mp="1o5vii76fzv01">
    <path d="M13.5 17L7.5 11L13.5 5" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" data-id="element-570" data-mp="10gke8fpvvih5" />
  </svg>;
const ChevronRight = () => <svg width="22" height="22" viewBox="0 0 22 22" fill="none" aria-hidden="true" data-id="element-571" data-mp="1af08uso4d9ve">
    <path d="M8.5 17L14.5 11L8.5 5" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" data-id="element-572" data-mp="15em7fth0wy6c" />
  </svg>;
export const HeroBannerSlider = () => {
  const [current, setCurrent] = useState(0);
  const [prev, setPrev] = useState<number | null>(null);
  const [transitioning, setTransitioning] = useState(false);
  const [isPaused, setIsPaused] = useState(false);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const [width, setWidth] = useState(1400);
  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;
    const ro = new ResizeObserver(([entry]) => {
      setWidth(entry.contentRect.width);
    });
    ro.observe(el);
    setWidth(el.getBoundingClientRect().width);
    return () => ro.disconnect();
  }, []);
  const isMobile = width <= 640;
  const isTablet = width > 640 && width <= 1280;
  const goTo = useCallback((index: number) => {
    if (transitioning || index === current) return;
    setPrev(current);
    setTransitioning(true);
    setTimeout(() => {
      setCurrent(index);
      setPrev(null);
      setTransitioning(false);
    }, 500);
  }, [current, transitioning]);
  const next = useCallback(() => {
    goTo((current + 1) % slides.length);
  }, [current, goTo]);
  const prevSlide = useCallback(() => {
    goTo((current - 1 + slides.length) % slides.length);
  }, [current, goTo]);
  useEffect(() => {
    if (isPaused) return;
    timerRef.current = setTimeout(next, 5000);
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [current, isPaused, next]);
  const slide = slides[current];
  const heroHeight = isMobile ? '580px' : isTablet ? '680px' : '800px';
  const contentPadding = isMobile ? '0 20px 46px' : isTablet ? '0 40px 48px' : '0 64px 56px';
  const titleFontSize = isMobile ? 'clamp(1.5rem, 7.2vw, 2.1rem)' : 'clamp(2rem, 5vw, 3.6rem)';
  const labelFontSize = isMobile ? '10px' : '11px';
  const labelPadding = isMobile ? '3px 11px' : '4px 14px';
  const subFontSize = isMobile ? '13px' : '15px';
  const pillFontSize = isMobile ? '11px' : '12px';
  const pillPadding = isMobile ? '4px 12px' : '5px 16px';
  const arrowSize = isMobile ? '34px' : '46px';
  const arrowInset = isMobile ? '10px' : '20px';
  return <div ref={containerRef} onMouseEnter={() => setIsPaused(true)} onMouseLeave={() => setIsPaused(false)} style={{
    position: 'relative',
    width: '100%',
    height: heroHeight,
    overflow: 'hidden',
    background: DS.color.tealDeep
  }} data-id="element-573" data-mp="vbqk3s30i643">
      {/* Slides */}
      {slides.map((s, i) => {
      const isActive = i === current;
      const isPrev = i === prev;
      return <div key={s.id} style={{
        position: 'absolute',
        inset: 0,
        opacity: isActive ? 1 : 0,
        transform: isActive ? 'scale(1)' : isPrev ? 'scale(1.04)' : 'scale(1)',
        transition: isActive ? 'opacity 0.6s ease, transform 6s ease' : isPrev ? 'opacity 0.5s ease, transform 0.5s ease' : 'none',
        zIndex: isActive ? 2 : isPrev ? 1 : 0
      }} data-id="element-574" data-mp="1e9bch94zjmtg" data-mpi={i}>
            <img src={s.image} alt={s.alt} style={{
          position: 'absolute',
          inset: 0,
          objectFit: 'cover',
          objectPosition: s.id === 1 ? isMobile ? '0% center' : isTablet ? '100% center' : 'center' : s.id === 2 && isMobile ? '34% center' : 'center',
          transform: s.id === 1 && isTablet ? 'scale(1.7) translate(8%, 4%)' : 'none',
          transformOrigin: s.id === 1 && isTablet ? '100% 45%' : 'center',
          width: '100%',
          height: '100%',
          display: 'block'
        }} data-id="element-575" data-mp="3o708w1zc4q21" />

            {/* Overlay oscuro */}
            <div aria-hidden="true" style={{
          position: 'absolute',
          inset: 0,
          background: s.overlay
        }} data-id="element-576" data-mp="16xds3w564ll2" />

            {/* Overlay gradiente inferior */}
            <div aria-hidden="true" style={{
          position: 'absolute',
          inset: 0,
          background: 'linear-gradient(to top, rgba(8,42,55,0.7) 0%, transparent 55%)'
        }} data-id="element-577" data-mp="x580womqq86x" />
          </div>;
    })}

      {/* Contenido encima */}
      <div style={{
      position: 'absolute',
      inset: 0,
      zIndex: 10,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-end',
      padding: contentPadding,
      textAlign: slide.align === 'center' ? 'center' : 'left',
      alignItems: slide.align === 'right' ? 'flex-end' : slide.align === 'center' ? 'center' : 'flex-start',
      transition: 'all 0.5s ease'
    }} data-id="element-578" data-mp="e7nbngg2d7ls">
        <div key={`label-${current}`} style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '7px',
        padding: labelPadding,
        borderRadius: DS.radius.pill,
        background: 'rgba(255,255,255,0.12)',
        backdropFilter: 'blur(8px)',
        WebkitBackdropFilter: 'blur(8px)',
        border: '1px solid rgba(255,255,255,0.2)',
        marginBottom: isMobile ? '12px' : '16px',
        animation: 'slideUp 0.5s ease both'
      }} data-id="element-579" data-mp="mlgljx9llwqb">
          <div style={{
          width: '6px',
          height: '6px',
          borderRadius: '50%',
          background: DS.color.aquaLight
        }} data-id="element-580" data-mp="1y2q3gfd2wgpi" />
          <span style={{
          fontFamily: DS.font.body,
          fontSize: labelFontSize,
          fontWeight: 700,
          color: 'rgba(255,255,255,0.85)',
          letterSpacing: '0.1em',
          textTransform: 'uppercase'
        }} data-id="element-581" data-mp="20luxwn0brsqg">
            {slide.label}
          </span>
        </div>

        <h2 key={`title-${current}`} style={{
        fontFamily: DS.font.heading,
        fontWeight: 800,
        fontSize: titleFontSize,
        color: '#fff',
        lineHeight: 1.12,
        letterSpacing: '-0.02em',
        margin: isMobile ? '0 0 10px' : '0 0 14px',
        whiteSpace: 'pre-line',
        textShadow: '0 2px 20px rgba(0,0,0,0.3)',
        animation: 'slideUp 0.55s ease 0.05s both',
        maxWidth: isMobile ? '320px' : 'none'
      }} data-id="element-582" data-mp="2fdn52bpyu0h3">
          {slide.title}
        </h2>

        <p key={`sub-${current}`} style={{
        fontFamily: DS.font.body,
        fontSize: subFontSize,
        color: 'rgba(255,255,255,0.75)',
        margin: isMobile ? '0 0 16px' : '0 0 20px',
        fontWeight: 500,
        animation: 'slideUp 0.6s ease 0.1s both',
        maxWidth: isMobile ? '300px' : 'none'
      }} data-id="element-583" data-mp="382kkm72slj65">
          {slide.sub}
        </p>

        <div key={`pill-${current}`} style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        padding: pillPadding,
        borderRadius: DS.radius.pill,
        background: `linear-gradient(135deg, ${DS.color.teal}55, ${DS.color.aqua}44)`,
        backdropFilter: 'blur(10px)',
        WebkitBackdropFilter: 'blur(10px)',
        border: `1px solid ${DS.color.aqua}55`,
        animation: 'slideUp 0.65s ease 0.15s both',
        maxWidth: isMobile ? '300px' : 'none'
      }} data-id="element-584" data-mp="3vkhw60833003">
          <span style={{
          fontFamily: DS.font.body,
          fontSize: pillFontSize,
          fontWeight: 700,
          color: '#fff',
          letterSpacing: '0.04em',
          whiteSpace: isMobile ? 'normal' : 'nowrap'
        }} data-id="element-585" data-mp="39bjku9jnut9p">
            {slide.pill}
          </span>
        </div>
      </div>

      {/* Flechas */}
      <button onClick={prevSlide} aria-label="Slide anterior" style={{
      position: 'absolute',
      left: arrowInset,
      top: '50%',
      transform: 'translateY(-50%)',
      zIndex: 20,
      width: arrowSize,
      height: arrowSize,
      borderRadius: '50%',
      background: 'rgba(255,255,255,0.12)',
      backdropFilter: 'blur(10px)',
      WebkitBackdropFilter: 'blur(10px)',
      border: '1.5px solid rgba(255,255,255,0.22)',
      color: '#fff',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      transition: `all 0.22s ${DS.ease.smooth}`
    }} onMouseEnter={e => {
      e.currentTarget.style.background = 'rgba(255,255,255,0.25)';
      e.currentTarget.style.borderColor = 'rgba(255,255,255,0.5)';
    }} onMouseLeave={e => {
      e.currentTarget.style.background = 'rgba(255,255,255,0.12)';
      e.currentTarget.style.borderColor = 'rgba(255,255,255,0.22)';
    }} data-id="element-586" data-mp="2qlbkfz7cigx7">
        <ChevronLeft data-id="element-587" data-mp="2s2h1tkukopj1" />
      </button>

      <button onClick={next} aria-label="Siguiente slide" style={{
      position: 'absolute',
      right: arrowInset,
      top: '50%',
      transform: 'translateY(-50%)',
      zIndex: 20,
      width: arrowSize,
      height: arrowSize,
      borderRadius: '50%',
      background: 'rgba(255,255,255,0.12)',
      backdropFilter: 'blur(10px)',
      WebkitBackdropFilter: 'blur(10px)',
      border: '1.5px solid rgba(255,255,255,0.22)',
      color: '#fff',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      transition: `all 0.22s ${DS.ease.smooth}`
    }} onMouseEnter={e => {
      e.currentTarget.style.background = 'rgba(255,255,255,0.25)';
      e.currentTarget.style.borderColor = 'rgba(255,255,255,0.5)';
    }} onMouseLeave={e => {
      e.currentTarget.style.background = 'rgba(255,255,255,0.12)';
      e.currentTarget.style.borderColor = 'rgba(255,255,255,0.22)';
    }} data-id="element-588" data-mp="2s1fn96eclkwk">
        <ChevronRight data-id="element-589" data-mp="q5qack4fkm6c" />
      </button>

      {/* Dots */}
      <div style={{
      position: 'absolute',
      bottom: isMobile ? '14px' : '20px',
      right: isMobile ? '16px' : '64px',
      zIndex: 20,
      display: 'flex',
      gap: '6px',
      alignItems: 'center'
    }} data-id="element-590" data-mp="le869n7425h5">
        {slides.map((_, i) => <button key={i} onClick={() => goTo(i)} aria-label={`Slide ${i + 1}`} style={{
        width: i === current ? isMobile ? '20px' : '32px' : '6px',
        height: '6px',
        borderRadius: '4px',
        background: i === current ? '#fff' : 'rgba(255,255,255,0.35)',
        border: 'none',
        cursor: 'pointer',
        padding: 0,
        transition: `all 0.3s ${DS.ease.smooth}`
      }} data-id="element-591" data-mp="2s3tmizcryzg9" data-mpi={i} />)}
      </div>

      {/* Barra de progreso inferior */}
      <div key={`progress-${current}`} aria-hidden="true" style={{
      position: 'absolute',
      bottom: 0,
      left: 0,
      height: '3px',
      background: `linear-gradient(90deg, ${DS.color.aquaLight}, ${DS.color.aqua})`,
      animation: isPaused ? 'none' : 'progressBar 5s linear both',
      zIndex: 20
    }} data-id="element-592" data-mp="3juq0y4ehhc5n" />

      {/* Keyframes */}
      <style data-id="element-593" data-mp="1mwshwhoru9m9">{`
        @keyframes slideUp {
          from { opacity: 0; transform: translateY(18px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        @keyframes progressBar {
          from { width: 0%; }
          to   { width: 100%; }
        }
      `}</style>
    </div>;
};